module.exports = __webpack_public_path__ + "static/img/curstage_5.5f74ddb5.png";